export default "__VITE_ASSET__0e0a60d5__"